export default __webpack_public_path__ + "static/media/ic_arrowleft16.21502a04.svg";